import React from "react";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { MenuItem } from "@mui/material";

function FontStyle({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      options={[
        <MenuItem key={"None"} value={""}>
          None
        </MenuItem>,
        <MenuItem key={"normal"} value={"normal"}>
          <span style={{ fontStyle: "normal" }}>Normal</span>
        </MenuItem>,
        <MenuItem key={"italic"} value={"italic"}>
          <span style={{ fontStyle: "italic" }}>Italic</span>
        </MenuItem>,
        <MenuItem key={"oblique"} value={"oblique"}>
          <span style={{ fontStyle: "oblique" }}>Oblique</span>
        </MenuItem>,
      ]}
      rules={{ required }}
    />
  );
}

export const JSFontStyleComponent: JSInputComponent = {
  Component: FontStyle,
  handlesCssProperties: ["fontStyle"],
};
